export default __webpack_public_path__ + "static/media/sweta.c58cad3c.png";